import React from 'react';

import blue from './assets/blue.png';
import pink from './assets/pink.png';
import purple from './assets/purple.png';

import cn from './AnimationCloud.module.scss';

interface AnimationCloudProps {
  children?: React.ReactNode;
}

export const AnimationCloud: React.FC<AnimationCloudProps> = ({ children }) => {
  return (
    <div className={cn.wrapper}>
      <div className={cn.cloud}>
        <div
          className={cn.position}
          style={{ top: '10%', left: '50%', transform: 'translateX(-50%)' }}
        >
          <img src={pink} className={cn.shape} style={{ animationDuration: '16s' }} />
        </div>
        <div className={cn.position} style={{ top: '10%', right: '-10%' }}>
          <img src={purple} className={cn.shape} style={{ animationDuration: '19s' }} />
        </div>
        <div className={cn.position} style={{ bottom: '10%', right: '-10%' }}>
          <img src={blue} className={cn.shape} style={{ animationDuration: '14s' }} />
        </div>
        <div
          className={cn.position}
          style={{ bottom: '10%', left: '50%', transform: 'translateX(-50%)' }}
        >
          <img src={pink} className={cn.shape} style={{ animationDuration: '22s' }} />
        </div>
        <div className={cn.position} style={{ top: '10%', left: '-10%' }}>
          <img src={purple} className={cn.shape} style={{ animationDuration: '15s' }} />
        </div>
        <div className={cn.position} style={{ bottom: '10%', left: '-10%' }}>
          <img src={blue} className={cn.shape} style={{ animationDuration: '17s' }} />
        </div>
      </div>
      <div className={cn.content}>{children}</div>
    </div>
  );
};
